// JobDescription.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaMapMarkerAlt, FaDollarSign, FaBriefcase } from 'react-icons/fa';
import { useParams, useNavigate } from 'react-router-dom';
import { url } from "../../data/url";

const EmployerJobDescription = () => {
  const [job, setJob] = useState(null);
  const { id } = useParams();
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [showAllSkills, setShowAllSkills] = useState(false);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const response = await axios.get(`${url.path}/employer/internship/${id}/description`);
        setJob(response.data);
      } catch (error) {
        if(error.response && error.response.status === 401) {
          navigate('/login');
        }
        console.error('Error fetching job:', error);
        setError('Error fetching job by the given id');
      }
    };

    fetchJob();
  }, [id, navigate]);

  if (!job) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const toggleSkills = () => {
    setShowAllSkills(!showAllSkills);
  };

  const displayedSkills = showAllSkills ? job.skills : job.skills.slice(0, 8);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const formatName = (type, splitOn) => {
    return type.split(splitOn).map(capitalizeFirstLetter).join(' ');
  };

  return (
    <div className="job-description-container">
    <div className="job-description">
      <header>
        <div>
        {job.company && job.company.logo && (
          <img src={job.company.logo} alt={`${job.company.name} logo`} />
        )}
        <h1>{job.jobTitle}</h1>
        <p><span className='company-name'>{job.company ? capitalizeFirstLetter(job.company.name) : 'Company'}</span> • Posted {new Date(job.createdAt).toLocaleDateString()} | Updated {new Date(job.updatedAt).toLocaleDateString()} </p>
        </div>
      </header>

      <section className="overview">
        <h2>Overview</h2>
        <div className="overview-item">
          <FaMapMarkerAlt className="overview-icon" />
          <span className="overview-text">{job.jobLocation}</span>
        </div>
        <div className="overview-item">
          <FaBriefcase className="overview-icon" />
          <span className="overview-text">{formatName(job.employmentType, '-')}</span>
        </div>
        {(job.maxPay > 0 || job.exactPay > 0) && (<div className="overview-item">
          <FaDollarSign className="overview-icon" />
          {(job.exactPay > 0) ? (<span className="overview-text">Up to ${job.exactPay.toLocaleString()}</span>) :
          (<span className="overview-text">Range ${job.minPay.toLocaleString()} - ${job.maxPay.toLocaleString()}</span>)}
        </div>)}
      </section>

      {job.skills && job.skills.length > 0 && (
        <section className="skills">
            <h2>Skills</h2>
            <div className="skill-tags">
            {displayedSkills.map((skill, index) => (
                <span key={index} className="skill-tag">{capitalizeFirstLetter(skill)}</span>
            ))}
            </div>
            {job.skills.length > 6 && (
            <button className="show-more-skills" onClick={toggleSkills}>
            {showAllSkills ? 'Show less' : `Show ${job.skills.length - 8} more`}
            </button>
            )}
        </section>
      )}

      <section className="job-details">
        <h2>Job Details</h2>
        {job.company && job.company.description && (
          <>
            <h4>About Us:</h4>
            <p>{capitalizeFirstLetter(job.company.description)}</p>
          </>
        )}

        {job.jobDescription && (
          <>
            <div dangerouslySetInnerHTML={{ __html: capitalizeFirstLetter(job.jobDescription) }} />
          </>
        )}

        {job.benefits && job.benefits.length > 0 && (
          <>
            <h4>Benefits and Perks:</h4>
            <ul>
              {job.benefits.map((benefit, index) => (
                <li key={index}>{formatName(benefit, '_')}</li>
              ))}
            </ul>
          </>
        )}

        {job.remote === 'yes' && (
          <>
            <h4>Work Location:</h4>
            <p>Remote | {job.streetAddress} {job.jobLocation}</p>
          </>
        )}
      </section>
    </div>
    </div>
  );
};

export default EmployerJobDescription;